/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CtaInputs */

const en_nav_cta = /** @type {(inputs: Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's talk`)
};

const lv_nav_cta = /** @type {(inputs: Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sazināties`)
};

/**
* | output |
* | --- |
* | "Let's talk" |
*
* @param {Nav_CtaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_cta = /** @type {((inputs?: Nav_CtaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CtaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_cta(inputs)
	return en_nav_cta(inputs)
});